/**
 * @module experience/shared-experience
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Injectable } from '@angular/core';
import {
  PlanRequest,
  SelectReasonRequest,
  AssessItemRequest,
} from '@experience/shared-experience/mixed-cart.interface';
import {
  OnDemandSessionPassInterface,
  SessionPass,
} from '@experience/change-plan-services/interface/on-demand-session-pass.interface';

@Injectable({
  providedIn: 'root',
})
export class MixedCartService {
  /**
   * initial configuration of component
   */
  public planRequestBody: PlanRequest;
  public showLineSelector: boolean;
  public sessionPassDetails: OnDemandSessionPassInterface;
  public sessionPassSelected: SessionPass;
  public selectedCategory: string;
  public selectReasonBody: SelectReasonRequest;
  public assessItemBody: AssessItemRequest;
  constructor() {}
}
